<template>
  <div class="container text-center min-vh-100">
    <h1>CitSci Newsletter</h1>
    <div>
      <p>
        Sign up for the CitSci
        <IconLink href="http://eepurl.com/g12_xn">Newsletter</IconLink>
      </p>
      <span class="text-muted">We use MailChimp to organize our newsletter sign ups</span>
    </div>
  </div>
  <!--    <b-container style="height:80vh;">-->
  <!--        <h1><i class="fas fa-envelope"></i> Sign Up for Our Newsletter</h1>-->
  <!--        &lt;!&ndash; Begin Mailchimp Signup Form &ndash;&gt;-->
  <!--        <div>-->
  <!--            <link href="//cdn-images.mailchimp.com/embedcode/classic-10_7.css" rel="stylesheet" type="text/css" />-->
  <!--            <div id="mc_embed_signup">-->
  <!--                &lt;!&ndash; swap action below to choose which list user subscribes to &ndash;&gt;-->
  <!--                <form-->
  <!--                    action='https://citsci.us5.list-manage.com/subscribe/post?u=8f0547118a9084cd6eeb2b3cf&amp;id=3e895f279c'-->
  <!--                    method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form"-->
  <!--                    class="validate py-4 px-0" target="_blank" novalidate>-->
  <!--                    <div id="mc_embed_signup_scroll" class="row">-->
  <!--                        <div class="col-md-8">-->
  <!--                            <div class="indicates-required">-->
  <!--                                <span class="asterisk">*</span> indicates required-->
  <!--                            </div>-->
  <!--                            <div class="mc-field-group">-->
  <!--                                <label for="mce-EMAIL">Email Address <span class="asterisk">*</span>-->
  <!--                                </label>-->
  <!--                                <input type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL" />-->
  <!--                            </div>-->
  <!--                            <div class="mc-field-group">-->
  <!--                                <label for="mce-FNAME">First Name </label>-->
  <!--                                <input type="text" value="" name="FNAME" class="" id="mce-FNAME" />-->
  <!--                            </div>-->
  <!--                            <div class="mc-field-group">-->
  <!--                                <label for="mce-LNAME">Last Name </label>-->
  <!--                                <input type="text" value="" name="LNAME" class="" id="mce-LNAME" />-->
  <!--                            </div>-->
  <!--                        </div>-->
  <!--                        <div class="col-md-4">-->
  <!--                            <div class="mc-field-group input-group">-->
  <!--                                <div class="font-weight-bold mb-2 w-100">Email Format</div>-->
  <!--                                <ul>-->
  <!--                                    <li>-->
  <!--                                        <input type="radio" value="html" name="EMAILTYPE" id="mce-EMAILTYPE-0"-->
  <!--                                            checked="checked" /><label for="mce-EMAILTYPE-0">&nbsp;html</label>-->
  <!--                                    </li>-->
  <!--                                    <li>-->
  <!--                                        <input type="radio" value="text" name="EMAILTYPE" id="mce-EMAILTYPE-1" /><label-->
  <!--                                            for="mce-EMAILTYPE-1">&nbsp;text</label>-->
  <!--                                    </li>-->
  <!--                                </ul>-->
  <!--                            </div>-->
  <!--                        </div>-->
  <!--                        <div class="col-12">-->
  <!--                            <div id="mce-responses" class="clear">-->
  <!--                                <div class="response" id="mce-error-response" style="display:none"></div>-->
  <!--                                <div class="response" id="mce-success-response" style="display:none"></div>-->
  <!--                            </div>-->
  <!--                            &lt;!&ndash; real people should not fill this in and expect good things - do not remove this or risk form bot signups&ndash;&gt;-->
  <!--                            <div style="position: absolute; left: -5000px;" aria-hidden="true">-->
  <!--                                <input type="text" name="b_8f0547118a9084cd6eeb2b3cf_6d5c0cc1e9" tabindex="-1"-->
  <!--                                    value="" />-->
  <!--                            </div>-->
  <!--                            <div class="clear">-->
  <!--                                <input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe"-->
  <!--                                    class="button" />-->
  <!--                            </div>-->
  <!--                        </div>-->
  <!--                    </div>-->
  <!--                </form>-->
  <!--            </div>-->
  <!--            <script type="application/javascript"-->
  <!--                src="//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js"></script>-->
  <!--            <script type="application/javascript">-->
  <!--      (function($) {-->
  <!--        window.fnames = new Array();-->
  <!--        window.ftypes = new Array();-->
  <!--        fnames[0] = "EMAIL";-->
  <!--        ftypes[0] = "email";-->
  <!--        fnames[1] = "FNAME";-->
  <!--        ftypes[1] = "text";-->
  <!--        fnames[2] = "LNAME";-->
  <!--        ftypes[2] = "text";-->
  <!--      })(jQuery);-->
  <!--      var $mcj = jQuery.noConflict(true);-->
  <!--    </script>-->
  <!--        </div>-->
  <!--    </b-container>-->

</template>
<script>
// import {mapActions, mapGetters} from 'vuex'
// import VueLoader from '../layout/Loader'
import IconLink from "../layout/IconLink.vue";

export default {
  // created() {
  // },

  // computed: {
  //   ...mapGetters({
  //     isLoading: 'newsletter/show/isLoading'
  //   })
  // },
  //
  // methods: {
  //   ...mapActions({
  //     preparePage: 'newsletter/show/preparePage'
  //   })
  // },

  components: {
    IconLink,
    // VueLoader
  }
}

</script>
